module.exports = __webpack_public_path__ + "img/logo_cbdb.ea71c32a.png";